'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _axiosInterceptWixResult = require('./axios-intercept-wix-result');

var _axiosInterceptWixResult2 = _interopRequireDefault(_axiosInterceptWixResult);

var _axiosInterceptBaseurl = require('./axios-intercept-baseurl');

var _axiosInterceptBaseurl2 = _interopRequireDefault(_axiosInterceptBaseurl);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var register = function register(axiosInstance, interceptor) {
  if (interceptor.requestSuccess || interceptor.requestError) {
    var interceptorId = axiosInstance.interceptors.request.use(interceptor.requestSuccess, interceptor.requestError);
    return function () {
      axiosInstance.interceptors.request.eject(interceptorId);
    };
  }

  if (interceptor.responseSuccess || interceptor.responseError) {
    var _interceptorId = axiosInstance.interceptors.response.use(interceptor.responseSuccess, interceptor.responseError);
    return function () {
      axiosInstance.interceptors.response.eject(_interceptorId);
    };
  }
};

var load = function load(axiosInstance) {
  var unregister = [register(axiosInstance, _axiosInterceptWixResult2.default), register(axiosInstance, _axiosInterceptBaseurl2.default)];

  return function () {
    return unregister.map(function (x) {
      return x();
    });
  };
};

var loadIfNeeded = function loadIfNeeded(axiosInstance, shouldLoadInterceptors) {
  if (shouldLoadInterceptors) {
    return load(axiosInstance);
  }

  return function () {};
};

exports.default = { load: load, loadIfNeeded: loadIfNeeded };
//# sourceMappingURL=axios-interceptors-loader.js.map



//////////////////
// WEBPACK FOOTER
// ../~/wix-axios-config/dist/src/axios-interceptors-loader.js
// module id = 491
// module chunks = 0